import React from 'react';
import { SchematicShell, Line } from './SchematicPrimitives';

const IN = 0.0254;
const CASTER_H = 1.5 * IN;
const TRAY_H = 3 * IN;
const TRAY_WALL = 0.5 * IN;
const LEG_W = 1 * IN;
const CASTER_R = 0.75 * IN;
const NUM_TIERS = 3;

export function DormRollingCartSchematic({
  widthMeters: width,
  heightMeters: height,
  depthMeters: depth,
  view = 'front',
  strokeColor,
  strokeWidth,
}) {
  const spanW = view === 'left' || view === 'right' ? depth : width;

  if (view === 'left' || view === 'right') {
    return (
      <SchematicShell
        width={depth}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      >
        <g
          transform={
            view === 'right'
              ? `scale(-1, 1) translate(${-depth}, 0)`
              : undefined
          }
        >
          <CartElevation
            span={depth}
            height={height}
            strokeColor={strokeColor}
            strokeWidth={strokeWidth}
          />
        </g>
      </SchematicShell>
    );
  }

  return (
    <SchematicShell
      width={width}
      height={height}
      strokeColor={strokeColor}
      strokeWidth={strokeWidth}
    >
      <CartElevation
        span={width}
        height={height}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    </SchematicShell>
  );
}

function CartElevation({ span, height, strokeColor, strokeWidth }) {
  const trayAreaH = height - CASTER_H;
  const traySpacing = trayAreaH / (NUM_TIERS - 1);
  const legInset = LEG_W;

  const elements = [];

  for (const side of [0, span - LEG_W]) {
    elements.push(
      <Line
        key={`leg-${side}`}
        x1={side + LEG_W / 2}
        y1={0}
        x2={side + LEG_W / 2}
        y2={height - CASTER_H}
        strokeColor={strokeColor}
        strokeWidth={strokeWidth}
      />
    );
  }

  for (let t = 0; t < NUM_TIERS; t++) {
    const trayTop = t * traySpacing;
    const trayBot = trayTop + TRAY_H;

    elements.push(
      <rect
        key={`tray-${t}`}
        x={0}
        y={trayTop}
        width={span}
        height={TRAY_H}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    );
  }

  for (const cx of [legInset, span - legInset]) {
    elements.push(
      <circle
        key={`caster-${cx}`}
        cx={cx}
        cy={height - CASTER_R}
        r={CASTER_R}
        fill="none"
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        vectorEffect="non-scaling-stroke"
      />
    );
  }

  return <g>{elements}</g>;
}

DormRollingCartSchematic.supportsSideViews = true;
